import { sqDocumentConstants } from '../../_constants';

export function salesQuotationDocuments(state = {}, action) {
    switch (action.type) {
        case sqDocumentConstants.SQ_DOCUMENT_FETCHING:
            return {
                ...state,
                sqDocFetching: true
            };
        case sqDocumentConstants.SQ_DOCUMENT_FETCHED:
            return {
                ...state,
                sqDocFetching: false
            };
        case sqDocumentConstants.SQ_DOCUMENT_SUBMITTING:
            return {
                ...state,
                sqDocSubmitting: true
            };
        case sqDocumentConstants.SQ_DOCUMENT_SUBMITTED:
            return {
                ...state,
                sqDocSubmitting: false
            };
        case sqDocumentConstants.GET_SQ_DOCUMENT_BY_SQDOCNUM:
            return {
                ...state,
                sqDocument: action.sqDocument
            };
        default:
            return state;
    }
}